import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@lt/components';

const GoToHotelButton = ({
  hotelUrl,
  children,
  primary,
  functional,
  className = '',
  ...htmlProps
}) => {
  const isLink = functional && !primary;
  return (
    <Button
      {...htmlProps}
      href={hotelUrl}
      rel="noopener noreferrer"
      size="flex"
      primary={primary}
      functional={isLink}
      as="a"
      className={className}
    >
      {children}
    </Button>
  );
};

GoToHotelButton.defaultProps = {
  primary: false,
  functional: true,
  target: '_blank',
};

GoToHotelButton.propTypes = {
  hotelUrl: PropTypes.string.isRequired,
  target: PropTypes.string,
  children: PropTypes.node.isRequired,
  primary: PropTypes.bool,
  functional: PropTypes.bool,
};

export default GoToHotelButton;
